import React from "react";
import Link from "gatsby-link";
import img from "../../assets/pages/home/solutions/solutions-cube.png";

const GetInTouch = () => (
  <section className="getInTouch">
    <div className="inner">
      <div className="item">
        <div className="icon">
          <img src={img} alt="FAST AND EASY SETUP" />
        </div>
        <div className="content">
          <h1>FAST AND EASY SETUP</h1>
          <p>
            Our DDoS mitigation services can be easily setup same day, without
            the need for any additional hardware or software. This translates to
            less downtime when under attacks and misconfiguration during setup.
          </p>
        </div>

        <div className="item">
          <div className="icon">
            <img src={img} alt="OPEN-SOURCE MULTI-LAYER SECURITY" />
          </div>
          <div className="content">
            <h1>OPEN-SOURCE MULTI-LAYER SECURITY</h1>
            <p>
              Our multi-layered, open-source security stack means thousands of
              experts have reviewed the code used to build our network and
              security foundation. This is the only way to ensure that our
              service has the least amount of vulnerabilities possible.
            </p>
          </div>
        </div>

        <div className="item">
          <div className="icon">
            <img src={img} alt="PRICING THAT MAKES SENSE" />
          </div>
          <div className="content">
            <h1>PRICING THAT MAKES SENSE</h1>
            <p>
              Sometimes it feels like security companies take advantage of those
              targeted by DDoS attacks by charging premium "under attack fees."
              Path Network offers affordable protection without taking advantage
              of those in an unfortunate situation.
            </p>
          </div>
        </div>

        <div className="item">
          <div className="icon">
            <img src={img} alt="TIER 3, 24X7 SUPPORT" />
          </div>
          <div className="content">
            <h1>TIER 3, 24X7 SUPPORT</h1>
            <p>
              Path has around the clock personalized support from experienced
              staff members. We offer clients a variety of communication methods
              such as phone, e-mail, and live chat to ensure any issues you face
              are solved as quickly and efficiently as possible.
            </p>
          </div>
        </div>

        <div className="cta">
          <Link to="/contact" className="button">
            <span>Get In Touch</span>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default GetInTouch;



// WEBPACK FOOTER //
// ./src/components/ddos-mitigation/getInTouch.js